const defaultCrudConfig = {
    endpoint: 'valuesets',
    primaryKey: 'valueSetId',
    globalSearchFieldName: 'text',
    globalSearchQueryClass: 'ByGeneralProperties',
    functions: {
        fetchAll: {
            method: 'get',
            returnType: 'Array',
            service: 'cds',
            args: [],
            query: {
                property: 'queryClass=FindAll'
            }
        }
    }
};

export default defaultCrudConfig;
